import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { TID } from "@/constants/testIds";
import { TriangleAlert, Loader2, RefreshCw, ExternalLink } from "lucide-react";
import { STATUS_COLOURS } from "./_shared";

export function AuditsTab({ audits, onSync, syncing, canSync }) {
  return (
    <div className="space-y-3">
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 flex items-start gap-3">
        <TriangleAlert className="w-5 h-5 text-amber-700 mt-0.5" />
        <div className="flex-1 text-sm text-amber-900">
          <div className="font-semibold">Safety Audits live in Aroflo</div>
          <p className="text-xs mt-0.5">Data below is synced from your Aroflo Safety Audit forms (WI-068). Click a row to open the audit in Aroflo.</p>
        </div>
        {canSync && (
          <Button data-testid={TID.hseqSyncAudits} onClick={onSync} disabled={syncing} size="sm" variant="outline" className="bg-white">
            {syncing ? <><Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> Syncing…</> : <><RefreshCw className="w-3.5 h-3.5 mr-1.5" /> Sync from Aroflo</>}
          </Button>
        )}
      </div>

      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
        <div className="grid gap-2 px-4 py-2.5 text-[11px] uppercase tracking-wider text-white bg-gbe" style={{ gridTemplateColumns: "0.9fr 1.8fr 0.7fr 0.9fr 0.7fr 0.9fr 0.7fr 0.5fr" }}>
          <div>Audit #</div>
          <div>Title</div>
          <div>BU</div>
          <div>Auditor</div>
          <div>Date</div>
          <div>Score</div>
          <div>Status</div>
          <div></div>
        </div>
        <div className="divide-y divide-slate-100">
          {audits.length === 0 && <div className="p-10 text-center text-sm text-slate-500">No audits synced yet.</div>}
          {audits.map((a) => (
            <div key={a.id} data-testid={TID.hseqAuditRow(a.id)} className="grid gap-2 px-4 py-3 text-sm items-center" style={{ gridTemplateColumns: "0.9fr 1.8fr 0.7fr 0.9fr 0.7fr 0.9fr 0.7fr 0.5fr" }}>
              <div className="font-mono text-xs text-slate-600">{a.audit_number}</div>
              <div className="text-slate-800 truncate">{a.title}</div>
              <div className="font-mono text-xs">{a.business_unit_code}</div>
              <div className="text-slate-600 text-xs truncate">{a.auditor}</div>
              <div className="text-slate-600 text-xs">{a.audit_date}</div>
              <div className="text-slate-900 font-semibold">{a.score_pct}%</div>
              <div><Badge className={`text-xs ${STATUS_COLOURS[a.status] || "bg-slate-100"}`}>{a.status?.replace("_", " ")}</Badge></div>
              <div className="text-right">
                <a href={a.aroflo_url} target="_blank" rel="noopener noreferrer" className="text-gbe hover:underline text-xs inline-flex items-center gap-1">
                  Open <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
